import React from 'react';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
import { useRef } from 'react';
import './sec1-gallery.css'
import pic51 from '../assets/pic51.png'
import pic52 from '../assets/pic52.png'
import pic53 from '../assets/pic53.png'



const Sec1gallery = ({ loading,}) => {

    const [headers, setheaders]= useState([]);

useEffect(() => {
const getheaders = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
setheaders(res.data);
}
getheaders();
}, []);



  const secRef = useRef(null);


useEffect(() => {
  if (loading) return;

  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, [loading]);





    return ( 
        <section className='sec1-containerp2'  ref={secRef}>
             <article className='sec1-sub-containerp3'>
                                <h1 className='header-herop2'>{headers?.[20]?.header}</h1>
                               <figure className='gallery-sec1-cont-imgs'>
                                    <img  className='center-img-gallery' src={pic53} alt='exbition gallery-photo'></img>
                                    <img className='left-img-gallery'  src={pic52} alt='exbition gallery-photo'></img>
                                    <img  className='right-img-gallery' src={pic51} alt='exbition gallery-photo'></img>
                               </figure>
            </article>





        </section>
     );
}
 
export default Sec1gallery;